export default {
  en: {
    settings: {
      placeholders: {
        selectGpgKey: 'Select Key'
      },
      titles: {
        keyInfoAddress: 'Key Address',
        keyInfoPublic: 'Public Key',
        keyInfoAddDate: 'Add Date',
        keyInfoExpireDate: 'End Date'
      }
    },
    package: {
      version: 'Version',
      createdAt: 'Published',
      owner: {
        inProject: 'In project',
        inTeam: 'In team',
        inCompany: 'In company'
      }
    },
    packages: {
      none: 'No packages'
    }
  },
  ru: {
    settings: {
      placeholders: {
        selectGpgKey: 'Выберите ключ'
      },
      titles: {
        keyInfoAddress: 'Адрес ключа',
        keyInfoPublic: 'Публичный ключ',
        keyInfoAddDate: 'Дата добавления',
        keyInfoExpireDate: 'Дата окончания'
      }
    },
    package: {
      version: 'Версия',
      createdAt: 'Опубликован',
      owner: {
        inProject: 'В проекте',
        inTeam: 'В команде',
        inCompany: 'В компании'
      }
    },
    packages: {
      none: 'Нет пакетов'
    }
  }
};
